import React from 'react';
import { MailCheck, MailWarning, Clock3 } from 'lucide-react';
import { Candidate } from '../api/candidate';

/** 无发送记录不展示，详情通过悬停或键盘聚焦展开，不增加表格列。 */
export function CandidateThankYouStatus({ candidate }: { candidate: Candidate }) {
  const record = candidate.thank_you_email;
  if (!record || record.status === 'not_sent') return null;
  const pending = record.status === 'queued' || record.status === 'sending';
  const sent = record.status === 'sent';
  const label = sent ? '邮件已发送' : pending ? '邮件发送中' : record.status === 'failed' ? '邮件发送失败' : '邮件结果待核实';
  const Icon = sent ? MailCheck : pending ? Clock3 : MailWarning;
  const color = sent ? 'text-emerald-600 bg-emerald-50' : pending ? 'text-blue-600 bg-blue-50' : record.status === 'failed' ? 'text-red-600 bg-red-50' : 'text-amber-600 bg-amber-50';
  const lines = [label, '按当前岗位和邮箱统计',
    record.last_sent_at ? `最近发送：${record.last_sent_at.replace('T', ' ').slice(0, 19)}` : '',
    !record.last_sent_at && record.last_attempt_at ? `操作时间：${record.last_attempt_at.replace('T', ' ').slice(0, 19)}` : '',
    record.shared ? '同岗位、同邮箱的其他候选人记录已产生投递' : '', record.reason].filter(Boolean);
  return (
    <span tabIndex={0} role="img" aria-label={lines.join('；')} title={lines.join('\n')}
      className={`ml-1 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded align-middle focus:outline-none focus:ring-2 focus:ring-blue-300 ${color}`}>
      <Icon className="h-3.5 w-3.5" aria-hidden="true" />
    </span>
  );
}
